import { OptionAvailability } from './../../model/industry';
import { HeaderComponent } from './../../portal/header/header.component';
import { Fragment } from './../../industryeditor/models/fragment';
import { FeatureDetail } from './../../model/feature';
import { Customer } from '../../model/customer';
import { environment } from '../../../environments/environment';
import { formatDate, registerLocaleData } from '@angular/common';
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from './configuration.service';
import localeIt from '@angular/common/locales/it';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { Feature, OptionInfo, OrderPreviewRows } from 'src/app/model/feature';
import { ItemsAdministrativeInfo } from 'src/app/model/configuration';
import { TranslatedVariables } from 'src/app/commons/translated-variables';
import { CalTypeObject, IndustryDescription, IndustryPurchasedInfo, SetIndustryPurchasedInfo } from 'src/app/model/industry';
import { CmsObject } from 'src/app/model/cmsobject';
import { CmsService } from 'src/app/core/services/cms.service';
import { OperationResult, TbAuthService } from '@tb/auth';
import { FragmentStatus } from 'src/app/industryeditor/models/industry-fragment';

@Injectable({
    providedIn: 'root',
})
export class PdfCreatorIndustriesCompareService {
    totalAmount = '';
    private loadedImages: any;
    private loadedStrings: any;
    private magoCLoudLogo = '';
    private microareazg = '';
    private circle = '';
    private circleFilled = '';
    private checked = '';
    private addAccount = '';
    private globo = '';
    private money = '';
    private calendar = '';
    private version = '';
    public isoAll: string = '';
    public isoDis = '';
    public featureDataSheet: CmsObject[];
    public currentIndustry: IndustryDescription;
    public FeaturesDetails: FeatureDetail[] = [];
    public FeaturesDetails_Complete: FeatureDetail[] = [];
    public currIndustryPurchInfo: IndustryPurchasedInfo = new IndustryPurchasedInfo();

    constructor(
        private configurationService: ConfigurationService,
        private http: HttpClient,
        private backend: HttpBackend,
        private variable: TranslatedVariables,
        public cmsService: CmsService
    ) {}

    public async getCmsObj(tempLang: string) {
        //carico le descrizioni e i titoli delle feature dal db
        await this.cmsService.getFeatureDataSheets();
    }
    async getSpecificIndustryStruct(
        setMinCal: boolean,
        ind: string,
        lang: string,
        accountName: string,
        productRelease: string,
        productID: string
    ) {
        let opResult: OperationResult = await this.configurationService.loadIndustrybyModuleCode(
            lang,
            ind,
            this.version,
            accountName,
            productRelease,
            '0', //si fanno vedere solo i fragment disponibili
            '0',
            productID
        );

        if (!opResult.Result) {
            //this.workflow.showMessage(this.variable.errorTitle, opResult.Message);
        } else {
            this.currentIndustry = opResult.Content as IndustryDescription;
            this.FeaturesDetails = [];
            this.addFeature(this.currentIndustry.Features, this.FeaturesDetails);
        }
        return this.currentIndustry;
    }

    private async createCompareIndustriesPDF(
        userlanguage: string,
        moduleCode: string,
        accountName: string,
        productRelease: string,
        productID: string
    ) {
        await this.getCmsObj(userlanguage);
        registerLocaleData(localeIt, userlanguage);
        this.version = await this.configurationService.getLatestIndustryVersion(moduleCode, productID);
        this.loadedImages = await this.getImages();
        await this.getSpecificIndustryStruct(true, moduleCode, userlanguage, accountName, productRelease, productID);

        var docDefinition = {
            pageSize: 'A4',
            pageOrientation: 'landscape',
            pageMargins: [40, 80, 40, 60],

            footer: function (currentPage, pageCount) {
                return {
                    table: {
                        headerRows: 0,
                        widths: ['*', '*'],
                        body: [
                            [
                                { text: formatDate(new Date(), 'longDate', userlanguage), style: 'dataStyle', margin: [40, 20, 50, 0] },
                                {
                                    text: currentPage.toString() + ' of ' + pageCount,
                                    alignment: 'right',
                                    style: 'dataStyle',
                                    margin: [0, 20, 50, 0],
                                },
                            ],
                        ],
                    },

                    layout: 'noBorders',
                };
            },
            header: {
                table: {
                    widths: ['25%', '50%', '25%'],
                    body: [
                        [
                            { image: 'logo', width: 100, style: 'headerLeftLogo', margin: [40, 20, 0, 0] },
                            { text: this.currentIndustry.TranslatedName, style: 'titleStyle', margin: [0, 20, 0, 0] },
                            { image: 'microareazg', width: 100, style: 'microareazgLogo', margin: [0, 20, 20, 0] },
                        ],
                    ],
                },
                layout: 'noBorders',
            },

            content: [
                this.tableSelectedFeature(this.FeaturesDetails, [
                    { text: this.variable.featuretxt, style: 'tableHeaderFirstTitle', fillColor: '#E0F1FF', margin: [2, 10, 2, 10] },
                    { text: '', style: 'tableHeaderSecondTitle', fillColor: '#E0F1FF', margin: [2, 10, 2, 10] },
                    { text: 'Standard', style: 'tableHeaderSecondTitle', fillColor: '#E0F1FF', margin: [2, 10, 2, 10] },
                    { text: 'Premium', style: 'tableHeaderSecondTitle', fillColor: '#E0F1FF', margin: [2, 10, 2, 10] },
                    { text: 'Professional', style: 'tableHeaderSecondTitle', fillColor: '#E0F1FF', margin: [2, 10, 2, 10] },
                    { text: 'Enterprise', style: 'tableHeaderSecondTitle', fillColor: '#E0F1FF', margin: [2, 10, 2, 10] },
                ]),

                { stack: [{ text: this.variable.explanation_line, style: 'titleLevel2Style', margin: [0, 40, 0, 0] }] },
                {
                    table: {
                        widths: ['2%', '12%', '2%', '24%', '2%', '58%'],
                        body: [
                            [
                                { image: 'circleFilled', width: 16 },
                                { text: this.variable.included_2, style: 'titleLevel3Style' },
                                { image: 'circle', width: 16 },
                                { text: this.variable.notIncluded, style: 'titleLevel3Style' },
                                { image: 'addAccount', width: 16 },
                                { text: this.variable.basedOnNumberUsers, style: 'titleLevel3Style' },
                            ],
                            [
                                { image: 'checked', width: 16 },
                                { text: this.variable.optional, style: 'titleLevel3Style' },
                                { image: 'globo', width: 16 },
                                { text: this.variable.only_available_some_country, style: 'titleLevel3Style' },
                                { image: 'money', width: 16 },
                                { text: this.variable.price_calculated_transactions, style: 'titleLevel3Style' },
                            ],
                        ],
                    },
                    layout: 'noBorders',
                },
            ],
            images: this.loadedImages,
            styles: {
                dataStyle: {
                    fontSize: 8,
                    bold: false,
                },
                titleStyle: {
                    fontSize: 16,
                    bold: true,
                    alignment: 'center',
                },
                descriTextStyle: {
                    fontSize: 8,
                    bold: false,
                    italics: true,
                },
                descriCountryTextStyle: {
                    fontSize: 8,
                    bold: true,
                },
                titleLevel1Style: {
                    fontSize: 14,
                    bold: true,
                    margin: [0, 5, 0, 0],
                },
                titleLevel2Style: {
                    fontSize: 12,
                    bold: true,
                    margin: [0, 5, 0, 0],
                },
                titleLevel3Style: {
                    fontSize: 10,
                    bold: true,
                    margin: [0, 2, 0, 0],
                },
                titleLevel4Style: {
                    fontSize: 10,
                    bold: true,
                    margin: [0, 5, 0, 0],
                },
                cellContent: {
                    margin: [0, 5, 0, 5],
                },
                headerLeftLogo: {
                    alignment: 'Left',
                    margin: [0, 20, 0, 20],
                },
                microareazgLogo: {
                    alignment: 'right',
                    margin: [0, 20, 0, 20],
                },
                tableHeaderSecondTitle: {
                    bold: true,
                    fontSize: 8,
                    alignment: 'center',
                },
                tableHeaderFirstTitle: {
                    bold: true,
                    fontSize: 8,
                    alignment: 'left',
                },
                iconStyle: {
                    alignment: 'center',
                    margin: [0, 10, 0, 10],
                },
            },
        };
        return docDefinition;
    }

    public async createPdfCompareIndustry(
        userlanguage: string,
        moduleCode: string,
        accountName: string,
        productRelease: string,
        productID: string
    ) {
        let docDefinition = await this.createCompareIndustriesPDF(userlanguage, moduleCode, accountName, productRelease, productID);
        const pdfDocGenerator = pdfMake.createPdf(docDefinition);
        return pdfDocGenerator;
    }

    public openPdf(pdfDocGenerator: any) {
        var base64data = null;
        pdfDocGenerator.getBase64(function (encodedString) {
            base64data = encodedString;
            var byteCharacters = atob(base64data);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            var file = new Blob([byteArray], { type: 'application/pdf;base64' });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
        });
        //pdfDocGenerator.open({ defaultFileName: 'compareVersion.pdf' });
    }

    private async addFeature(data: Feature[], rows: FeatureDetail[]) {
        data.forEach((row) => {
            let r: FeatureDetail = new FeatureDetail();
            if (row.Status == 0) {
                r.itemDescription = row.Description.toString();
                r.DenyISO = row.DenyISO ? row.DenyISO.toString() : '';
                r.AllowISO = row.AllowISO ? row.AllowISO.toString() : '';
                r.Details = this.cmsService.getFeatureDataSheetDetail(row.Fragment);
                r.OptionsSTD = row.Options[0].availability.toString();
                r.OptionsPRM = row.Options[1].availability.toString();
                r.OptionsPRO = row.Options[2].availability.toString();
                r.OptionsENT = row.Options[3].availability.toString();
                r.Level = row.Level.toString();
                rows.push(r);
            }
        });
    }

    private tableSelectedFeature(data, columns) {
        let t =
            data.length > 0
                ? {
                      table: {
                          headerRows: 1,
                          dontBreakRows: true,
                          widths: ['*', 20, 50, 50, 50, 50],
                          body: this.buildTableBody(data, columns),
                      },
                      layout: {
                          hLineWidth: function (i, node) {
                              return i === 0 || i === node.table.body.length ? 1 : 1;
                          },
                          vLineWidth: function (i, node) {
                              return i === 0 || i === node.table.widths.length ? 1 : 1;
                          },
                          hLineColor: function (i, node) {
                              return i === 0 || i === node.table.body.length ? '#c6d0e9' : '#E0F1FF';
                          },
                          vLineColor: function (i, node) {
                              return i === 0 || i === node.table.widths.length ? '#c6d0e9' : '#E0F1FF';
                          },
                      },
                  }
                : '';
        return t;
    }

    private async getImages() {
        this.magoCLoudLogo = await this.getBase64('./assets/MAGOCLOUD-logo.png');
        this.microareazg = await this.getBase64('./assets/Zuc_Orizz_B_Small.png');
        this.circleFilled = await this.getBase64('./assets/icons/icons8-cerchio-pieno-256.png');
        this.circle = await this.getBase64('./assets/icons/icons8-cerchio-256.png');
        this.addAccount = await this.getBase64('./assets/icons/icons8-aggiungere-utente-uomo-256.png');
        this.checked = await this.getBase64('./assets/icons/icons8-casella-di-controllo-selezionata-2-256.png');
        this.globo = await this.getBase64('./assets/icons/icons8-globo-256.png');
        this.money = await this.getBase64('./assets/icons/icons8-soldi-256.png');
        this.calendar = await this.getBase64('./assets/icons/icons8-calendario-256.png');

        let img = {
            logo: this.magoCLoudLogo,
            microareazg: this.microareazg,
            circle: this.circle,
            circleFilled: this.circleFilled,
            addAccount: this.addAccount,
            checked: this.checked,
            globo: this.globo,
            money: this.money,
            calendar: this.calendar,
        };
        return img;
    }

    private buildTableBody(data: FeatureDetail[], columns) {
        var body = [];
        body.push(columns);
        let i = 0;
        var notAv = this.variable.notAvailableIn;
        var av = this.variable.availableIn;

        data.forEach(function (row) {
            var dataRow = [];
            var dataRowDesc = [];
            var dataRowISO = [];
            var styleTitleFeature = '';
            let denyISO: string = row.DenyISO ? row.DenyISO.toString() : '';
            let allowISO: string = row.AllowISO ? row.AllowISO.toString() : '';

            switch (row.Level.toString()) {
                case '1':
                    styleTitleFeature = 'titleLevel1Style';
                    break;
                case '2':
                    styleTitleFeature = 'titleLevel2Style';
                    break;
                case '3':
                    styleTitleFeature = 'titleLevel3Style';
                    break;
                default:
                    styleTitleFeature = 'titleLevel4Style';
                    break;
            }

            var iconSTDTemp = '';
            switch (row.OptionsSTD.toString()) {
                case OptionAvailability.ALWAYS:
                    iconSTDTemp = 'circleFilled';
                    break;
                case '':
                case OptionAvailability.EMPTY:
                    iconSTDTemp = 'circle';
                    break;
                case OptionAvailability.COUNT:
                    iconSTDTemp = 'addAccount';
                    break;
                case OptionAvailability.OPTIONAL:
                case OptionAvailability.STANDALONE:
                    iconSTDTemp = 'checked';
                    break;
                case OptionAvailability.PPT.toUpperCase():
                    iconSTDTemp = 'money';
                    break;
                default:
                    '';
                    break;
            }

            var iconPRMTemp = '';
            switch (row.OptionsPRM.toString()) {
                case OptionAvailability.ALWAYS:
                    iconPRMTemp = 'circleFilled';
                    break;
                case '':
                    iconPRMTemp = 'circle';
                    break;
                case OptionAvailability.COUNT:
                    iconPRMTemp = 'addAccount';
                    break;
                case OptionAvailability.OPTIONAL:
                case OptionAvailability.STANDALONE:
                    iconPRMTemp = 'checked';
                    break;
                case OptionAvailability.PPT.toUpperCase():
                    iconPRMTemp = 'money';
                    break;
                default:
                    '';
                    break;
            }

            var iconPROTemp = '';
            switch (row.OptionsPRO.toString()) {
                case OptionAvailability.ALWAYS:
                    iconPROTemp = 'circleFilled';
                    break;
                case '':
                    iconPROTemp = 'circle';
                    break;
                case OptionAvailability.COUNT:
                    iconPROTemp = 'addAccount';
                    break;
                case OptionAvailability.OPTIONAL:
                case OptionAvailability.STANDALONE:
                    iconPROTemp = 'checked';
                    break;
                case OptionAvailability.PPT.toUpperCase():
                    iconPROTemp = 'money';
                    break;
                default:
                    '';
                    break;
            }

            var iconENTTemp = '';
            switch (row.OptionsENT.toString()) {
                case OptionAvailability.ALWAYS:
                    iconENTTemp = 'circleFilled';
                    break;
                case '':
                    iconENTTemp = 'circle';
                    break;
                case OptionAvailability.COUNT:
                    iconENTTemp = 'addAccount';
                    break;
                case OptionAvailability.OPTIONAL:
                case OptionAvailability.STANDALONE:
                    iconENTTemp = 'checked';
                    break;
                case OptionAvailability.PPT.toUpperCase():
                    iconENTTemp = 'money';
                    break;
                default:
                    '';
                    break;
            }

            dataRow.push({
                stack: [
                    { text: row.itemDescription.toString(), style: styleTitleFeature, fillColor: '#ffffff' },
                    denyISO != ''
                        ? { text: '(' + notAv + ' ' + denyISO + ')', style: 'descriCountryTextStyle', fillColor: '#ffffff' }
                        : { text: '', fillColor: '#ffffff' },
                    allowISO != ''
                        ? { text: '(' + av + ' ' + allowISO + ')', style: 'descriCountryTextStyle', fillColor: '#ffffff' }
                        : { text: '', fillColor: '#ffffff' },
                    { text: row.Details.toString(), style: 'descriTextStyle', fillColor: '#ffffff' },
                ],
                style: 'cellContent',
            });

            allowISO != '' || denyISO != ''
                ? dataRow.push({ image: 'globo', style: 'iconStyle', width: 15, fillColor: '#F1F5F9' })
                : dataRow.push({ text: '', fillColor: '#F1F5F9' });

            dataRow.push({ image: iconSTDTemp, style: 'iconStyle', width: 15, fillColor: '#F1F5F9' });

            dataRow.push({ image: iconPRMTemp, style: 'iconStyle', width: 15, fillColor: '#F1F5F9' });

            dataRow.push({ image: iconPROTemp, style: 'iconStyle', width: 15, fillColor: '#F1F5F9' });

            dataRow.push({ image: iconPROTemp, style: 'iconStyle', width: 15, fillColor: '#F1F5F9' });

            body.push(dataRow);
            i++;
        });
        return body;
    }

    private async GetStringFromBlob(blob: any): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (event: any) => {
                resolve(event.target.result);
            };
            reader.onerror = (event: any) => {
                reject('NO');
            };
            const binaryString = reader.readAsDataURL(blob);
        });
    }
    private async getBase64(url: string) {
        let blob = await this.http.get(url, { responseType: 'blob' }).toPromise();
        return await this.GetStringFromBlob(blob);
    }
}
